<!--德茵定制单位看板-->
<template>
	<div class="unitOverviewBody">
		<!--左边-->
		<indexLeft :dayXTimeData="dayXTimeData" ></indexLeft>
		<!--中间-->
		<indexCenter></indexCenter>
		<!--右边-->
		<indexRight></indexRight>
	</div>
</template>

<script>
	import indexLeft from '@/page/projectDingZhi/deyin/unitOverview/indexLeft.vue'
	import indexCenter from '@/page/projectDingZhi/deyin/unitOverview/indexCenter.vue'
	import indexRight from '@/page/projectDingZhi/deyin/unitOverview/indexRight.vue'
	export default {
		components: {
			indexLeft,
			indexCenter,
			indexRight,
		},
		props: {},
		data() {
			return {
				theDayPower:[]
			}
		},
		created() {
			debugPage=this
		},
		mounted() {
			/*this.initData()*/
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			dayXTimeData() {
				//获取当前时间的整点值
				let list = []
				for(let i = 0; i <= new Date().format('hh'); i++) {
					if(i < 10) {
						list.push('0' + i + ":00")
					} else {
						list.push(i + ":00")
					}
				}
				return list
			}
		},
		watch: {
			nowUnit(nv, ov) {
				this.initData()
			}
		},
		methods: {
			initData() {
				//获取数据
				//查询单位下的能耗设备
				this.$api.deviceApi.getDeviceByUnitIdAndDeviceType(this.nowUnit.id, "power", respon => {
					 
				})
			}
		}
	}
</script>

<style scoped>
	.unitOverviewBody {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: space-around;
		background-color: #0a2b6a;
	}
	
	.dyin_left {
		width: 25%;
		height: 99%;
	}
	
	.dyin_center {
		width: 48%;
		height: 99%;
	}
	
	.dyin_right {
		width: 25%;
		height: 99%;
	}
</style>